import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../lib/api';
import useIsMobile from '../../lib/useIsMobile';
import useSEO from '../../lib/useSEO';
import MarketingNav from './MarketingNav';
import Footer from './Footer';

const C = {
  bg: '#FAFBFC',
  white: '#FFFFFF',
  navy: '#1B2B4B',
  accent: '#2563EB',
  green: '#16A34A',
  muted: '#64748B',
  light: '#94A3B8',
  border: '#E2E8F0',
};

function formatDate(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function BlogPage() {
  const isMobile = useIsMobile();
  useSEO({ title: 'Cost Segregation Blog | ClearSeg', description: 'Expert insights on cost segregation, accelerated depreciation, and tax savings for rental property owners.', canonical: 'https://clearseg.com/blog' });
  const [apiPosts, setApiPosts] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/blog/posts')
      .then(res => setApiPosts(res.data || []))
      .catch(() => setApiPosts([]))
      .finally(() => setLoading(false));
  }, []);

  const displayPosts = apiPosts || [];

  return (
    <div style={{ background: C.bg, minHeight: '100vh' }}>
      <MarketingNav />

      <section style={{ padding: isMobile ? '48px 24px 32px' : '80px 24px 48px', textAlign: 'center' }}>
        <h1 style={{
          color: C.navy, fontSize: isMobile ? 32 : 48, fontWeight: 800,
          letterSpacing: -1.5, margin: '0 0 12px', lineHeight: 1.1,
        }}>
          ClearSeg Blog
        </h1>
        <p style={{
          color: C.muted, fontSize: isMobile ? 16 : 18, margin: 0, maxWidth: 500, marginLeft: 'auto', marginRight: 'auto',
        }}>
          Insights for rental property investors
        </p>
      </section>

      <section style={{ maxWidth: 900, margin: '0 auto', padding: isMobile ? '0 20px 60px' : '0 24px 80px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 24 }}>
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: C.muted, fontSize: 15 }}>Loading posts...</div>
          ) : displayPosts.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 0', color: C.muted, fontSize: 15 }}>No posts yet. Check back soon.</div>
          ) : displayPosts.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              style={{ textDecoration: 'none', display: 'block' }}
            >
              <article
                style={{
                  background: C.white,
                  border: `1px solid ${C.border}`,
                  borderRadius: 12,
                  padding: isMobile ? 24 : 32,
                  transition: 'border-color 0.2s, transform 0.2s',
                  cursor: 'pointer',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor = C.accent;
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor = C.border;
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                <div style={{ display: 'flex', gap: 16, marginBottom: 12, fontSize: 13, color: C.light }}>
                  <span>{formatDate(post.date)}</span>
                  <span>{post.readTime}</span>
                </div>
                <h2 style={{
                  color: C.navy, fontSize: isMobile ? 20 : 24, fontWeight: 700,
                  margin: '0 0 12px', lineHeight: 1.3, letterSpacing: -0.5,
                }}>
                  {post.title}
                </h2>
                <p style={{
                  color: C.muted, fontSize: 15, lineHeight: 1.7, margin: '0 0 16px',
                }}>
                  {post.excerpt}
                </p>
                <span style={{ color: C.accent, fontSize: 14, fontWeight: 600 }}>
                  Read More &rarr;
                </span>
              </article>
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
